
import { Search } from 'vant';

export default {
  name: 'home',
  components: {
    [Search.name]: Search
  },
  data () {
    return {
      customerName: this.$store.state.customerName || '',
    }
  },
  methods: {

  },
  created () {
    window.scrollTo(0,0);
  }
}
